




























import { Component, Vue } from 'vue-property-decorator';
import LeafletsModlue from '@/store/modules/leaflets';
import { Config } from '@/types/config';

@Component
export default class Navbar extends Vue {
  // 操作可能モード
  private show = process.env.VUE_APP_SHOW_CONTROL === 'true';

  // 再生中かどうか
  private playing = false;

  // ストアアクションの購読解除関数
  private unsubscribe?: Function;

  // イベント用メソッド
  private handleKeyupBind = this.handleKeyup.bind(this);

  // 印刷機能の有効／無効
  private isPrintActivate = true;

  /**
   * 前のページボタンの可否
   *
   * @readonly
   * @type {boolean}
   */
  private get enabledPrevPage() {
    const leaflet = LeafletsModlue.current;
    if (leaflet !== null) {
      return leaflet.items.length > 2;
    }
    return false;
  }

  /**
   * 次のページボタンの可否
   *
   * @readonly
   * @type {boolean}
   */
  private get enabledNextPage() {
    const leaflet = LeafletsModlue.current;
    if (leaflet !== null) {
      return leaflet.items.length > 1;
    }
    return false;
  }

  /**
   * 前のページボタンのラベル
   *
   * @readonly
   * @type {string}
   */
  private get prevPageLabel() {
    const leaflet = LeafletsModlue.current;
    if (leaflet !== null) {
      const prevPage = LeafletsModlue.getPrevPage;
      if (leaflet.items.length > 2) {
        // 2ページより多いときは、前のページ数を表示
        return prevPage + 1 + 'P';
      }
    }
    // 2ページ以下のときは、ページ送りなし表記
    return 'なし';
  }

  /**
   * 次のページボタンのラベル
   *
   * @readonly
   * @type {string}
   */
  private get nextPageLabel() {
    const leaflet = LeafletsModlue.current;
    if (leaflet !== null) {
      const nextPage = LeafletsModlue.getNextPage;
      if (leaflet.items.length > 2) {
        // 2ページより多いときは、次のページ数を表示
        return nextPage + 1 + 'P';
      } else if (leaflet.items.length === 2) {
        // 2ページのみのときは、表面か裏面のトグル
        if (nextPage === 0) {
          return '表面';
        } else {
          return '裏面';
        }
      }
    }
    // 1ページ以下のときは、ページ送りなし表記
    return 'なし';
  }

  created() {
    const config: Config = Vue.prototype.$config;
    if (config.print !== undefined) {
      if (config.print.activate !== undefined) {
        this.isPrintActivate = config.print.activate;
      }
    }
  }

  activated() {
    this.playing = LeafletsModlue.isPlaying;

    // モジュール監視
    this.unsubscribe = this.$store.subscribe(mutation => {
      if (mutation.type === 'leaflets/setPlaying') {
        this.playing = LeafletsModlue.isPlaying;
      }
    });

    // 非タッチパネルデバイス対応のため、キーボードでも操作可能にする
    window.addEventListener('keyup', this.handleKeyupBind);
  }

  deactivated() {
    this.unsubscribe && this.unsubscribe();
    window.removeEventListener('keyup', this.handleKeyupBind);
  }

  /**
   * 前チラシ表示
   */
  private prev() {
    LeafletsModlue.prev();
  }

  /**
   * 次チラシ表示
   */
  private next() {
    LeafletsModlue.next();
  }

  /**
   * 前ページ表示
   */
  private prevPage() {
    LeafletsModlue.prevPage();
  }

  /**
   * 次ページ表示
   */
  private nextPage() {
    LeafletsModlue.nextPage();
  }

  /**
   * 停止
   */
  private stop() {
    LeafletsModlue.stop();
  }

  /**
   * 再生
   */
  private play() {
    LeafletsModlue.play();
  }

  /**
   * 印刷を実行
   */
  private print() {
    LeafletsModlue.print();
  }

  /**
   * 非タッチパネルデバイス対応のため、キーボードでも操作可能にする
   *
   * @protected
   * @param {KeyboardEvent} event
   */
  protected handleKeyup(event: KeyboardEvent) {
    switch (event.code) {
      case 'Digit1':
      case 'Numpad1':
        // 前チラシ表示
        this.prev();
        break;
      case 'Digit3':
      case 'Numpad3':
        // 次チラシ表示
        this.next();
        break;
      case 'Digit5':
      case 'Numpad5':
      case 'NumpadSubtract':
        // 前ページ表示
        this.prevPage();
        break;
      case 'Digit2':
      case 'Numpad2':
      case 'NumpadAdd':
        // 次ページ表示
        this.nextPage();
        break;
      case 'Space':
      case 'Digit0':
      case 'Numpad0':
        // 自動再生 停止／再開
        this.playing ? this.stop() : this.play();
        break;
      case 'NumpadMultiply':
        // 印刷
        // 印刷ボタンが非表示の場合は無効とする
        if (this.isPrintActivate) {
          this.print();
        }
        break;
    }
  }
}
